import type { ApiConfig } from '@api/types';
import { typedMethodPost, typedMethodGet } from '@api/utils';
import type { SearchMachinesRequestDto, SearchMachinesResponseDto } from '@api/generated/models';
import type { GetScheduledParams, ScheduledOperationsResponse as ScheduledOperationsResponseLocal } from './types';

// Domain types
import type { SearchMachinesResponse, ScheduledOperationsResponse } from '@api/domain/types';

// Mappers
import { toSearchMachinesResponse, toScheduledOperationsResponse } from '@api/domain/mappers';

export default ({ baseURL }: ApiConfig) => ({
  get: typedMethodGet<GetScheduledParams, ScheduledOperationsResponseLocal, ScheduledOperationsResponse>(
    (data) =>
      fetch(`${baseURL}/v1/machines/${data.params.id}/scheduled`, {
        method: 'GET',
        headers: data.headers,
      }),
    toScheduledOperationsResponse
  ),
  searchMachines: typedMethodPost<SearchMachinesRequestDto, SearchMachinesResponseDto, SearchMachinesResponse>(
    (data) =>
      fetch(`${baseURL}/v1/machines/search`, {
        method: 'POST',
        ...data,
      }),
    toSearchMachinesResponse
  ),
});

// Re-export domain types for consumers
export type { SearchMachinesResponse, ScheduledOperationsResponse };
export type { GetScheduledParams } from './types';
